export const sentryConfig = {
  dsn: 'https://680de5b98f555f216be30b16fe82183e@o4504436440432640.ingest.us.sentry.io/4508399349334016',
  propagationTarget: ["https://3303.ua/"],
  authToken: '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',
  debug: false,
  release: 'sushi@1.0.0'
}
